import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    teams:[],
    error:'',
    status:'idle',
    addTeam:{}
};

export const fetchTeams = createAsyncThunk('teams/fetchTeams', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('register/getAllUsers',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const addNewTeam = createAsyncThunk('teams/addNewTeam', async (initialPost) => {
    let url = '';
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("firstname",initialPost.firstname);
    fromData.append("lastname",initialPost.lastname);
    fromData.append("username",initialPost.email);
    fromData.append("phone",initialPost.phone);
    fromData.append("password",initialPost.password);
    fromData.append("Token",accessToken);
    if(initialPost.id){
        url = 'register/UpdateTeamMember';
        fromData.append("id",initialPost.id);
    }else{
        url = 'register/AddTeamMember';
    }
    let response = await axios.post(url,fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const TeamSlice = createSlice({
    name:'teams',
    initialState,
    reducers:{
        blankAddTeam:(state)=>{
            state.addTeam = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchTeams.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchTeams.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.teams = action.payload;
            state.error = '';
        })
        builder.addCase(fetchTeams.rejected,(state,action)=>{
            state.status = 'failed';
            state.teams = [];
            state.error = action.error.message;
        })
        builder.addCase(addNewTeam.fulfilled,(state,action)=>{
            // state.contacts.push(action.payload)
            // state.status="idle";
            state.addTeam = action.payload
        })
    }
});

export const {blankAddTeam} = TeamSlice.actions;

export default TeamSlice.reducer;
